import { TherapyPaymentType } from '../TherapyPlans';

export interface AdminCreateOrUpdatePacksRequest {
  id?: string;
  visible: boolean;
  active: boolean;
  packName: string;
  subTitle: string;
  packDescription: string;
  slugName: string;
  internalPackName: string;
  packagePicture: string;
  packageCardPicture: string;
  disciplineDetails: string[][];
  // setupScreenCarousal: {
  //   title: string;
  //   description: string;
  // }[];
  variations: PacksVariation[];
  packTags: PackageTags[];
  primaryTherapistExpertiseId: string;
  assessmentPrompt?: string;
  primarySesssionDuration?: number;
  auxiliarySessionDuration?: number;
  isTestPack: boolean;
}

export interface AdminGetPacksResponse extends AdminCreateOrUpdatePacksRequest {
  therapistDetails?: {
    id: string;
    name: string;
  }[];
  primaryTherapistExpertiseName: string;
  primaryConcern: string[];
  auxilaryTherapistDetails: {
    therapistName: string;
    expertiseName: string[];
  }[];
}

export enum PackageTags {
  MOST_POPULAR = 'Most Popular',
  TRENDING_NOW = 'Trending Now',
  ANYO_FAVORITES = 'Anyo Favorites',
  TOP_PICK = 'Top Pick',
  RESULTS_DRIVEN = 'Results Driven',
  EXPERT_CURATED = 'Expert Curated',
  BACKED_BY_SCIENCE = 'Backed by Science',
  CLINICALLY_INSPIRED = 'Clinically Inspired',
}

export enum VariantTags {
  BEST_VALUE = 'Best Value',
  SAVE_MORE = 'Save More',
  MORE_FOR_LESS = 'More for Less',
  GREATEST_SAVINGS = 'Greatest Savings',
  SMART_PICK = 'Smart Pick',
  QUICK_START = 'Quick Start',
  TOP_CHOICE = 'Top Choice',
}

export interface PacksVariation {
  id?: string;
  variantName: string;
  variantTags: VariantTags[];
  charges: {
    amount: number;
    markupAmount: number;
    savingText: string;
    perSessionAmount: number;
  };
  noOfSessions: {
    primary: number;
    auxiliary: number[];
  };
  packageDuration: number;
  paymentType: TherapyPaymentType;
}
